import { render, staticRenderFns } from "./CdnInvalidation.vue?vue&type=template&id=325c50fe&scoped=true"
import script from "./CdnInvalidation.vue?vue&type=script&lang=js"
export * from "./CdnInvalidation.vue?vue&type=script&lang=js"
import style0 from "./CdnInvalidation.vue?vue&type=style&index=0&id=325c50fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325c50fe",
  null
  
)

export default component.exports